/* oxlint-disable */
import Crypto from 'crypto';

import { errors } from '@/features/dashboard/localization/texts';

import { ALGORITHM, LOCAL } from '@/constants/core';

const randomString = (length:number, string:boolean = false):string => {
  const chars = string ? 'abcdefghijklmnopqrstuvwxyz' : '0123456789abcdefghijklmnopqrstuvwxyz';
  let data = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    data += chars[randomIndex];
  }

  return data;
};
export const decrypt = async (data: string, tag: string): Promise<string | string> => {
  try {
    if (data && tag) {
      const key = Buffer.from(process.env.NEXT_PUBLIC_CRYPTO_SECRET_KEY!, 'base64');
      const iv = Buffer.from(process.env.NEXT_PUBLIC_CRYPTO_SECRET_IV!, 'base64');

      const decipher = Crypto.createDecipheriv(ALGORITHM, key, iv);

      const authTag = Buffer.from(tag, 'base64');
      decipher.setAuthTag(authTag);
      const encryptedData = Buffer.from(data, 'base64');
      let decrypted = decipher.update(encryptedData);
      decrypted = Buffer.concat([decrypted, decipher.final()]);
      return decrypted.toString('utf8');
    }
    return errors.tryAgain;
  } catch (error: any) {
    return errors.tryAgain;
  }
};

export const exception = async (message: any, info: { route: string, method: string, req: any }): Promise<void> => {
  console.log('message', message);
  console.log('info', info);
  if (process.env.NEXT_PUBLIC_APP_ENV !== LOCAL && message !== null) {
    console.error('Exception occurred:', message, 'Info:', info);
  }
};

export function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export const moneyFormat = (amount: string | number) => {
  const data = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount));

  return data;
};

export const formatMoneyWithCurrency = (amount: string | number, currency?: string): string => {
  const symbols: Record<string, string> = {
    GTQ: 'Q',
    DOP: 'RD$',
    USD: 'US$',
  };

  const symbol = currency ? (symbols[currency] || 'US$') : 'US$';
  const formattedAmount = moneyFormat(amount);

  return `${symbol} ${formattedAmount}`;
};

export const checkNumber = (value: number): boolean => {
  if (value && typeof value === 'number' && value !== undefined && !Number.isNaN(value) && value > 0) return true;
  return false;
};

export const extractNumberOfFakeUuid = (value: string): number => {
  return parseInt(value.split('-')[0].replace(/[^0-9]/g, ''), 10);
};

export const fakeUuid = (value: string): string => {
  const data = `${value}${randomString(8 - value.length, true)}-${randomString(4)}-4${randomString(3)}-y${randomString(3)}-${randomString(12)}`;
  return data;
};

export const checkUserId = (userId: number): boolean => {
  if (userId && typeof userId === 'number' && userId !== undefined) return true;
  return false;
};

export const formatUnits = (unit: string) => {
  switch (unit) {
    case 'days':
      return 'Días';
    case 'hours':
      return 'Horas';
    case 'minutes':
      return 'Minutos';
    default:
      return '';
  }
};

export const resendEmailVerification = async (): Promise<boolean> => {
  try {
    const request = await fetch('/api/resend-email-verification', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const response = await request.json();
    if (response.ok) return true;
    return false;
  } catch (error) {
    return false;
  }
};

export const getDatGames = async (games: string[], type: string) => {
  // const favoritesParam = games.length > 0 ? `favorites=${games.join(',')}` : '';

  try {
    const res = await fetch('/api/casino/games', {
      method: 'POST',
      body: JSON.stringify({ favorites: games, type }),
      cache: 'force-cache',
      next: { revalidate: 60 },
    });
    const game = await res.json();
    return game;
  } catch (error) {
    return [];
  }
};

export const getDataGamesTournaments = async (games: string[], type: string, provider: string) => {
  // const favoritesParam = games.length > 0 ? `favorites=${games.join(',')}` : '';

  try {
    const res = await fetch('/api/casino/games', {
      method: 'POST',
      body: JSON.stringify({ favorites: games, type, provider }),
      cache: 'force-cache',
      next: { revalidate: 60 },
    });
    const game = await res.json();
    return game;
  } catch (error) {
    return [];
  }
};

export const validateEmail = (email: string) => {
  const blockedEmails = process.env.NEXT_PUBLIC_BLOCKED_EMAILS?.split(',') || [];
  const emailDomain = email.split('@')[1].split('.')[0];
  return blockedEmails.includes(emailDomain);
};

export const isValidEmailFormat = (email: string | null | undefined): boolean => {
  if (!email || typeof email !== 'string') return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

export interface ValidateAmountInputParams {
  value: string;
  minDeposit: number;
  maxDeposit: number;
  currency?: string;
}

export function validateAmountInput({
  value,
  minDeposit,
  maxDeposit,
  currency,
}: ValidateAmountInputParams): string {
  if (value === '') return '';
  if (!/^\d*\.?\d*$/.test(value) || /^\.+$/.test(value)) return 'El monto debe ser un número';
  if (value.length > 10) return 'El monto no puede exceder 10 dígitos';
  const numericValue = parseFloat(value);
  if (Number.isNaN(numericValue)) return '';
  if (numericValue < minDeposit) {
    return `El monto mínimo de depósito es ${formatMoneyWithCurrency(minDeposit, currency)}`;
  }
  if (numericValue > maxDeposit) {
    return `El monto máximo de depósito es ${formatMoneyWithCurrency(maxDeposit, currency)}`;
  }
  return '';
}

export interface ValidateDepositAmountParams {
  amount: string | number;
  minDeposit: number;
  maxDeposit: number;
  currency?: string;
}

export interface ValidateDepositAmountResult {
  isValid: boolean;
  errorMessage?: string;
}

export function validateDepositAmountBeforeSubmit({
  amount,
  minDeposit,
  maxDeposit,
  currency,
}: ValidateDepositAmountParams): ValidateDepositAmountResult {
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

  if (Number.isNaN(numericAmount) || numericAmount <= 0) {
    return {
      isValid: false,
      errorMessage: 'El monto debe ser un número válido mayor a cero',
    };
  }

  if (numericAmount < minDeposit) {
    return {
      isValid: false,
      errorMessage: `El monto mínimo de depósito es ${formatMoneyWithCurrency(minDeposit, currency)}`,
    };
  }

  if (numericAmount > maxDeposit) {
    return {
      isValid: false,
      errorMessage: `El monto máximo de depósito es ${formatMoneyWithCurrency(maxDeposit, currency)}`,
    };
  }

  return { isValid: true };
}

export interface DepositAmountOption {
  label: string;
  value: number;
}

export function filterValidDepositAmounts(
  amounts: DepositAmountOption[],
  minDeposit: number,
  maxDeposit: number,
): DepositAmountOption[] {
  return amounts.filter((amount) => {
    return amount.value >= minDeposit && amount.value <= maxDeposit;
  });
}

export function getDefaultDepositAmount(
  amounts: DepositAmountOption[],
  minDeposit: number,
  maxDeposit: number,
): number {
  const validAmounts = filterValidDepositAmounts(amounts, minDeposit, maxDeposit);
  if (validAmounts.length === 0) {
    return minDeposit;
  }
  const firstValidAmount = validAmounts[0];
  if (firstValidAmount.value >= minDeposit) {
    return firstValidAmount.value;
  }
  return minDeposit;
}

export function isDepositAmountValid(
  amount: string | number,
  minDeposit: number,
  maxDeposit: number,
): boolean {
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (Number.isNaN(numericAmount) || numericAmount <= 0) {
    return false;
  }
  if (numericAmount < minDeposit || numericAmount > maxDeposit) {
    return false;
  }
  return true;
}

export function capitalizeName(name: string | null | undefined): string {
  if (!name || typeof name !== 'string') return '';

  return name
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter((word) => { return word.length > 0; })
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

